import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, IndexRoute, browserHistory} from 'react-router';

import {createStore} from 'redux';
import {Provider} from 'react-redux';

import isLoggedIn from './utils/auth';
import configureStore from './utils/configureStore';

import {AppContainer} from './components/common/App';

import {AppAuthContainer} from './components/common/AppAuth';
import {DashboardContainer} from './components/views/dashboard/Dashboard';
import {LabTransfersContainer} from './components/views/transfers/LabTransfers';
import {TransfersContainer} from './components/views/transfers/Transfers';

import AppExt from './components/common/AppExt';
import {LoginContainer} from './components/views/login/Login';
import {VideoIframeContainer} from './components/views/video/VideoIframe';

const store = configureStore();

require('./styles/main.scss');
require('normalize.css');
require('react-datepicker/dist/react-datepicker.css');

function requireAuth(nextState, replaceState, cb) {
  if(!isLoggedIn()) {
    replaceState({ pathname: '/login' });
  }
  cb();
}

function checkAuth(nextState, replaceState, cb) {
	if(isLoggedIn()) {
    replaceState({ pathname: '/' });
	}
	cb();
}

ReactDOM.render(
	<Provider store={store}>
	  <Router onUpdate={() => window.scroll(0, 0)} history={browserHistory}>
	    <Route path='/' component={AppContainer}>
	    	<Route component={AppAuthContainer} onEnter={requireAuth}>
	    		<IndexRoute component={DashboardContainer} />
	    		
	    		<Route path='lab/closed' component={LabTransfersContainer} fullHistory={true} pendingTransfers={false} />
	    		<Route path='lab/pending' component={LabTransfersContainer} fullHistory={false} pendingTransfers={true} />
	    		<Route path='lab/transfers' component={LabTransfersContainer} fullHistory={false} pendingTransfers={false} />

	    		<Route path='closed' component={TransfersContainer} fullHistory={true} pendingTransfers={false} />
	    		<Route path='pending' component={TransfersContainer} fullHistory={false} pendingTransfers={true} />
	    		<Route path='transfers' component={TransfersContainer} fullHistory={false} pendingTransfers={false} />

	    	</Route>
	      <Route component={AppExt} onEnter={checkAuth}>
	      	<Route path='login' component={LoginContainer} />
	      </Route>
	      <Route path='video' component={VideoIframeContainer} />
	    </Route>
	  </Router>
  </Provider>,
  document.getElementById('dd-transfer-app')
);